export default __webpack_public_path__ + "static/article-time-to-upgrade-your-car-82420b04dc8a56d6d3265b2c5743d344.jpeg";